import React, { useState } from "react";
import Aux from "../../../hoc/Auxiliary/Auxiliary";
import Search from "../../UI/Search/Search";
import SearchIcon from '@material-ui/icons/Search';
import styles from "./searchData.module.css"
import Tooltip from '@mui/material/Tooltip';
import {useMediaQuery} from "react-responsive";

const SearchData = (props) => {
    const [searchinput, setSearchInput] = useState("");
    const [currentKey, setCurrentKey] = useState("");
    let isSmallScreen = useMediaQuery ({
        query: `(max-width: ${ props.smallScreenThreshold ?
            props.smallScreenThreshold : "66rem" })`
    })
    let title = isSmallScreen ? <SearchIcon/> : <span>Search</span>
    let icone = isSmallScreen ? <span></span> :  <SearchIcon className={styles.searchIcon} />
    function handleSearch() {
        setCurrentKey(key => { return searchinput });
        props.search(searchinput);
    }

    return (
        <Aux>
            <div className={styles.searchContainer}>
                {icone}
                <Search changed={(event) => setSearchInput(event.target.value)} pushedClass={props.pushedClass}  handleSearch={handleSearch} disabled={searchinput === currentKey || props.isDisabled}/>
                <Tooltip title={props.tooltipTitle}>
                <button className={styles.searchButton} onClick={() => handleSearch()} disabled={searchinput === currentKey || props.isDisabled}>
                    {title}
                </button>
                </Tooltip>

            </div>
        </Aux >
    );
};

export default SearchData;
